import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import { addJobs, getFeaturedJobsByGroup } from "../FeaturedJobsService";
import { basicSort } from "../../../App/Helpers/BasicSort";
import { callAPI } from "../../../App/Helpers/callApi";
import { searchJobs } from "../../../App/Services/JobsService";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    minWidth: "20vw",
    display: "flex",
    flexDirection: "column",
  },
  search: {
    position: "relative",
    paddingLeft: "5px",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "rgba(0,0,0,.1)",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,.2)",
    },
    marginBottom: "20px",
    width: "80%",
    "&.Mui-focused": {
      width: "100%",
      transition: "width 0.3s",
    },
    transition: "width 0.3s",
    [theme.breakpoints.down("md")]: {
      width: "50%",
      "&.Mui-focused": {
        width: "100%",
        transition: "width 0.3s",
      },
    },
  },
  copy: {
    color: theme.palette.primary.copy,
  },
  searchButton: {
    marginTop: "15px",
    marginLeft: "10px",
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
    },
  },
}));

export default function FeatureJobAddModal({
  openModal,
  setTableData,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  client,
}) {
  const classes = useStyles();
  const [searchedJobs, setSearchedJobs] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [processing, setProcessing] = useState(false);

  const callSearchJobs = () => {
    searchJobs(client.id, searchVal).then((res) => {
      res.forEach((row) => (row.add = false));
      setSearchedJobs(res);
    });
  };

  const callAddJobs = () => {
    var addJobsList = [];
    for (var i in searchedJobs) {
      if (searchedJobs[i].add) {
        addJobsList.push(searchedJobs[i]);
      }
    }

    callAPI(
      addJobs(client.id, undefined, addJobsList),
      "Jobs Added",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getFeaturedJobsByGroup(client.id).then((response) => {
        response.sort((a, b) => {
          const order = basicSort(a.order, b.order);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        setTableData(response);
        openModal(false);
      });
    });
  };

  const updateAdded = (index) => {
    var copy = [...searchedJobs];
    copy[index].add = !copy[index].add;

    setSearchedJobs(copy);
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Add Featured Jobs
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={9}>
                <TextField
                  placeholder="Ref. Numbers ( ; delimited - no spaces)"
                  label="Ref. Numbers ( ; delimited - no spaces)"
                  variant="standard"
                  fullWidth
                  required
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={searchVal}
                  onChange={(e) => setSearchVal(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Button
                  className={classes.searchButton}
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => callSearchJobs()}
                >
                  Search
                </Button>
              </Grid>
              {searchedJobs.map((job, index) => (
                <TableRow key={index} style={{ width: "100%" }}>
                  <TableCell align="left" style={{ width: "50%" }}>
                    {job.title}
                  </TableCell>
                  <TableCell align="middle" style={{ width: "50%" }}>
                    {job.referenceNumber}
                  </TableCell>
                  <TableCell align="right" style={{ width: "50%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={job.add}
                          onChange={() => updateAdded(index)}
                        />
                      }
                      label=""
                    />
                  </TableCell>
                </TableRow>
              ))}
              {searchedJobs.length > 0 ? (
                <Grid
                  container
                  justifyContent="flex-end"
                  direction="row"
                  style={{ marginRight: "10px" }}
                >
                  <Grid item xs={6} sm={3}>
                    <Button
                      style={{ color: "#82B288", marginTop: "20px" }}
                      type="submit"
                      variant="outlined"
                      fullWidth
                      onClick={() => openModal(false)}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <Button
                      style={{ marginTop: "20px", marginLeft: "10px" }}
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={() => callAddJobs()}
                    >
                      Add
                    </Button>
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
